/* eslint-disable */

import { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { MainLayout } from 'views/layouts'
import {
  Container,
  Content,
  SelectorsContainer,
  FooterContent,
  HeaderContainer,
  OptionsGrid,
  OptionCard,
  OptionHeader,
  OptionIndicator,
  OptionText,
  OptionEyebrow,
  OptionTitle,
  OptionDescription,
  NewBadge,
} from './styled'
import Stepper from 'views/components/Stepper'
import { H2, P } from 'views/components/UI/Text'
import { Button, BackButton } from 'views/components/UI/Buttons'
import ModalLoader from 'views/components/UI/ModalLoader/modal-loader'
import ModalConfirmDeleteEditedRoleFamily from './modal-confirm-delete-edited-rolefamily'
import { platformAdminRoutes } from 'router/routes'
import InfoRoleFamilyContainer from 'views/containers/RoleFamily/infoRoleFamily'
import AlertComponent from 'views/components/Alert'
import {
  stepOneSelector,
  stepTwoSelector,
  setStepTwoTrigger,
  setLoading as setLoadingProcess,
  setStepThreeTrigger,
  setStepFourTrigger,
  stepFourSelector,
  stepFiveSelector,
  setUserListAdded,
  cleanStepsFromThree,
} from 'ducks/createProcess'
import { RoleFamily as IRoleFamily, Level as ILevel } from 'types/common'
import { STEPS_NEW_PROCESS } from '../constants'
import { generalDataSelector } from 'ducks/auth'
import getRoleFamilyByFilters from 'services/rolFamily/fetchGetRoleFamilyByLevel'
import lodash from 'lodash'
import { parseQuadrantFullNameToShortName } from 'utils/common'
import { User } from '../Users/constants'
import useDeleteUsersInProcess from 'hooks/process/useDeleteUsersInProcess/use-delete-users-in-process'
import { deleteModelProcessAssociation } from 'views/screens/super-admin/homologation-skills/services/deleteModelProcessAssociation'
import { useGetCreditsAvailables } from 'hooks/inventory/useInventory'
import { useTranslation } from 'react-i18next'

function RoleFamily() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { data: generalData } = useSelector(generalDataSelector)
  const stepOneData = useSelector(stepOneSelector)
  const stepTwoData = useSelector(stepTwoSelector)
  const stepFourData = useSelector(stepFourSelector)
  const stepFiveData = useSelector(stepFiveSelector)
  const initialConfigurationMode = stepTwoData?.configurationMode
    || (stepTwoData?.isRoleFamilySelected === true
      ? 'role_family'
      : null)
  const levelOptions = generalData?.level
  const hasEditedRoleFamily = stepFourData?.isEditingRoleFamily

  const { deleteUsersInProcess, deleteTestsInProcess } = useDeleteUsersInProcess()

  const [showAlert, setShowAlert] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [showModalConfirmDeleteEditedRoleFamily, setShowModalConfirmDeleteEditedRoleFamily] = useState<boolean>(false)

  const [nameRoleFamilySelected, setNameRoleFamilySelected] = useState<string>(stepTwoData?.roleFamilyName || '')
  const [editingRoleFamily, setEditingRoleFamily] = useState(false)
  const [configurationMode, setConfigurationMode] = useState<'role_family' | 'manual' | 'ai_ideal_profile' | null>(
    initialConfigurationMode
  )
  const [roleFamilies, setRoleFamilies] = useState<IRoleFamily[]>([])
  const [roleFamily, setRoleFamily] = useState<any>()

  const { refreshCredits } = useGetCreditsAvailables(stepOneData.inventoryTypeId)

  useEffect(() => {
    if (stepFiveData?.userListAdded) {
      dispatch(setUserListAdded([]))
      const idUsersToDelete = stepFiveData?.userListAdded
        .map((user: User) => user.id)
        .filter((id: number) => id !== undefined)

      if (idUsersToDelete.length > 0) {
        deleteUsersInProcess(stepOneData.processId, idUsersToDelete)
      }
      refreshCredits()
    }
  }, [])

  useEffect(() => {
    const levelSelected = levelOptions?.find((level: ILevel) => level.id === stepOneData.level)?.name || ''
    getRoleFamilyByFilters({ level: levelSelected }).then((res) => {
      if (res.status === 'OK') {
        setRoleFamilies(res.roleFamilies)
      }
    })
  }, [stepTwoData, stepOneData, generalData, levelOptions])

  useEffect(() => {
    if (configurationMode !== 'role_family') {
      setNameRoleFamilySelected('')
    }
  }, [configurationMode])

  useEffect(() => {
    if (
      stepTwoData?.configurationMode === 'ai_ideal_profile' &&
      stepTwoData?.processId &&
      editingRoleFamily !== true
    ) {
      navigate(platformAdminRoutes.IdealProfileGeneratorAi, {
        replace: true,
      })
    }
  }, [
    editingRoleFamily,
    navigate,
    stepTwoData?.configurationMode,
    stepTwoData?.processId,
  ])

  const handleCreateProcessFromScratch = async () => {
    // Limpiar estados de pasos posteriores antes de crear proceso desde cero
    dispatch(cleanStepsFromThree())

    // Eliminar tests y modelo de proceso existentes antes de continuar
    try {
      await deleteTestsInProcess(stepOneData.processId)
      await deleteModelProcessAssociation(stepOneData.processId)
    } catch (error) {
      console.error('Error al limpiar tests y modelo:', error)
    }

    dispatch(
      setStepTwoTrigger.run({
        isRoleFamilySelected: false,
        processId: stepOneData.processId,
        configurationMode: 'manual',
      }),
    )
    navigate(platformAdminRoutes.SelectTestsType)
  }

  const handleCreateProcessWithRoleFamily = async () => {
    const profileValueEdited = stepFourData.betesaIdealProfile?.profileValues
      ? stepFourData.betesaIdealProfile?.profileValues.map((item: any) => {
          return {
            quadrant: parseQuadrantFullNameToShortName(item.quadrant),
            priority: item.priority,
            min: item.min,
            max: item.max,
          }
        })
      : roleFamily?.ideal_profile?.map((item: any) => {
          return {
            quadrant: parseQuadrantFullNameToShortName(item.quadrant),
            priority: item.priority,
            min: item.min,
            max: item.max,
          }
        })

    const competencesIdealProfile = stepFourData.competencesIdealProfile
      ? stepFourData.competencesIdealProfile?.map((item: any) => {
          return {
            skill_id: item.skill_id || item.id,
            weight: item.weight,
          }
        })
      : roleFamily?.competence_skills?.map((item: any) => {
          return {
            skill_id: item.skill_id || item.id,
            weight: item.weight,
          }
        })

    const betesaIdealProfile = {
      alertLevelId: stepFourData?.betesaIdealProfile?.alertLevelId || roleFamily?.ideal_profile[0]?.alert_level_range,
      profileValues: profileValueEdited,
      betesaSkills: [],
    }

    if (loading) {
      return
    }
    setLoading(true)

    const dispatchWithDelay = (action: any, delay: any) => {
      lodash.delay(() => {
        dispatch(action)
      }, delay)
    }

    // Eliminar tests y modelo de proceso antes de crear los nuevos
    // Esto previene errores de test_id no encontrado cuando se cambia de familia de rol
    try {
      await deleteTestsInProcess(stepOneData.processId)
      await deleteModelProcessAssociation(stepOneData.processId)

      // Esperar un momento para asegurar que el backend procesó la eliminación
      await new Promise(resolve => setTimeout(resolve, 200))
    } catch (error) {
      console.error('Error al limpiar tests y modelo:', error)
    }

    dispatchWithDelay(
      setStepTwoTrigger.run({
        isRoleFamilySelected: true,
        processId: stepOneData.processId,
        roleFamilyName: nameRoleFamilySelected,
        configurationMode: 'role_family',
      }),
      0
    )

    // Primero crear los tests (test_selection)
    dispatchWithDelay(
      setStepThreeTrigger.run({
        processId: stepOneData.processId,
        onlineCourse: false,
        useBetesaTest: roleFamily.ideal_profile.length > 1,
        useSkillsTest: roleFamily.competence_skills.length > 1,
        use360Test: false,
      }),
      300
    )

    const dataUpdateStepFour: any = {
      processId: stepOneData.processId,
      isEditingRoleFamily: Object.keys(stepFourData).length > 0,
    }

    if (betesaIdealProfile.alertLevelId) {
      dataUpdateStepFour.betesaIdealProfile = betesaIdealProfile
    }

    if (competencesIdealProfile.length > 0) {
      dataUpdateStepFour.competencesIdealProfile = competencesIdealProfile
    }

    // IMPORTANTE: Aumentar delay a 2000ms para asegurar que los tests se crearon
    // antes de enviar el perfil ideal. El backend necesita tiempo para:
    // 1. Recibir test_selection (300ms)
    // 2. Crear los tests en BD
    // 3. Generar los test_id
    // Solo después se puede enviar ideal_profile con esos test_id
    if (Object.keys(dataUpdateStepFour).length) {
      dispatchWithDelay(setStepFourTrigger.run(dataUpdateStepFour), 2000)
      lodash.delay(() => {
        setLoading(false)
        navigate(platformAdminRoutes.CreateUsers)
      }, 2500)
      return
    }
    dispatchWithDelay(setStepFourTrigger.run(dataUpdateStepFour), 2000)
    lodash.delay(() => {
      setLoading(false)
      navigate(platformAdminRoutes.CreateUsers)
    }, 2500)
  }

  return (
    <MainLayout>
      <Container>
        <HeaderContainer>
          <H2 margin="10px 0px 40px 20px">Familia de rol</H2>
          <Stepper activeStep={editingRoleFamily ? 3 : 1} steps={STEPS_NEW_PROCESS} />
        </HeaderContainer>
        <Content>
          <SelectorsContainer>
            <P>Elige cómo quieres configurar este proceso</P>
            <OptionsGrid>
              <OptionCard
                type="button"
                $active={configurationMode === 'ai_ideal_profile'}
                $featured
                onClick={() => {
                  setConfigurationMode('ai_ideal_profile')
                  dispatch(cleanStepsFromThree())
                }}
              >
                <OptionHeader>
                  <OptionText>
                    <OptionEyebrow>Opción 1</OptionEyebrow>
                    <OptionTitle>
                      Generador de perfil ideal con IA Bluesite Lumina
                    </OptionTitle>
                  </OptionText>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 10,
                    }}
                  >
                    <NewBadge>Nuevo</NewBadge>
                    <OptionIndicator
                      $active={configurationMode === 'ai_ideal_profile'}
                    />
                  </div>
                </OptionHeader>
                <OptionDescription>
                  Carga el perfil del cargo y deja que Bluesite Lumina
                  sugiera Betesa y 3D Skills como punto de partida
                  editable.
                </OptionDescription>
              </OptionCard>

              <OptionCard
                type="button"
                $active={configurationMode === 'manual'}
                onClick={() => {
                  setConfigurationMode('manual')
                  dispatch(cleanStepsFromThree())
                }}
              >
                <OptionHeader>
                  <OptionText>
                    <OptionEyebrow>Opción 2</OptionEyebrow>
                    <OptionTitle>Configuración desde cero</OptionTitle>
                  </OptionText>
                  <OptionIndicator
                    $active={configurationMode === 'manual'}
                  />
                </OptionHeader>
                <OptionDescription>
                  Define manualmente las pruebas, el perfil ideal y la
                  configuración paso a paso.
                </OptionDescription>
              </OptionCard>

              <OptionCard
                type="button"
                $active={configurationMode === 'role_family'}
                onClick={() => {
                  setConfigurationMode('role_family')
                  dispatch(cleanStepsFromThree())
                }}
              >
                <OptionHeader>
                  <OptionText>
                    <OptionEyebrow>Opción 3</OptionEyebrow>
                    <OptionTitle>Familia de rol</OptionTitle>
                  </OptionText>
                  <OptionIndicator
                    $active={configurationMode === 'role_family'}
                  />
                </OptionHeader>
                <OptionDescription>
                  Usa una parametrización ya estructurada por familia de
                  rol y acelera la configuración del proceso.
                </OptionDescription>
              </OptionCard>
            </OptionsGrid>
          </SelectorsContainer>
          {configurationMode === 'role_family' && (
            <InfoRoleFamilyContainer
              onEditRoleFamily={(e) => {
                setRoleFamily(e)
              }}
              defaultRole={nameRoleFamilySelected}
              onSelectRole={(e: string) => {
                // Si se selecciona una familia de rol diferente, limpiar estados posteriores
                if (e !== nameRoleFamilySelected) {
                  dispatch(cleanStepsFromThree())
                }
                setNameRoleFamilySelected(e)
              }}
              options={roleFamilies}
              onChangeEditingRoleFamily={(e: boolean) => setEditingRoleFamily(e)}
            />
          )}
          {configurationMode !== 'role_family' && <></>}
        </Content>
        {editingRoleFamily !== true && configurationMode !== 'role_family' && (
          <FooterContent>
            <BackButton onClick={() => navigate(platformAdminRoutes.CreateProcess)} />
            <Button
              disabled={
                configurationMode === null
              }
              onClick={() => {
                if (configurationMode === 'manual') {
                  handleCreateProcessFromScratch()
                }

                if (configurationMode === 'ai_ideal_profile') {
                  navigate(platformAdminRoutes.IdealProfileGeneratorAi)
                }
              }}
              style={{
                padding: '10px 20px',
              }}
              type="button"
            >
              {configurationMode === 'ai_ideal_profile'
                ? 'Generar perfil ideal'
                : 'Selección de pruebas'}
            </Button>
          </FooterContent>
        )}
        {configurationMode === 'role_family' && !editingRoleFamily && (
          <FooterContent>
            <BackButton
              onClick={() => {
                if (hasEditedRoleFamily || (stepTwoData.roleFamilyName && stepFourData.processId)) {
                  setShowModalConfirmDeleteEditedRoleFamily(true)
                } else {
                  navigate(platformAdminRoutes.CreateProcess, { replace: true })
                }
              }}
            />
            <Button
              disabled={!nameRoleFamilySelected}
              type="submit"
              onClick={handleCreateProcessWithRoleFamily}
              onDisabledClick={() => {
                setShowAlert(true)
                setTimeout(() => {
                  setShowAlert(false)
                }, 3000)
              }}
            >
              {t('global.common.nextButtonText')}
            </Button>
          </FooterContent>
        )}
      </Container>
      {showModalConfirmDeleteEditedRoleFamily && (
        <ModalConfirmDeleteEditedRoleFamily
          visible={showModalConfirmDeleteEditedRoleFamily}
          onAccept={() => {
            // Limpiar estados al volver atrás después de editar familia de rol
            dispatch(cleanStepsFromThree())
            dispatch(setLoadingProcess(false))
            navigate(platformAdminRoutes.CreateProcess, { replace: true })
          }}
          onCancel={() => setShowModalConfirmDeleteEditedRoleFamily(false)}
        />
      )}
      <ModalLoader isLoading={loading} />
      <AlertComponent message="Primero debes seleccionar una familia de rol" severity="warning" open={showAlert} />
    </MainLayout>
  )
}

export default RoleFamily
